import { LookupValue } from "../../common/lookup-value";

export class PatientHistory {
  id: number;
  historyEventType: LookupValue;
  subject: string;
  description: string;
  eventDate: string;
  createdDatetime: string;
  createdBy: string;
  updatedDatetime: string;
  updatedBy: string;
  createdById: number;
  updatedById: number;
  selected: boolean = false;

  constructor(
    id: number,
    historyEventType: LookupValue,
    subject: string,
    description: string,
    eventDate: string,
    createdDatetime: string,
    createdBy: string,
    updatedDatetime: string,
    updatedBy: string,
    createdById: number,
    updatedById: number
  ) {
    this.id = id;
    this.historyEventType = historyEventType;
    this.subject = subject;
    this.description = description;
    this.eventDate = eventDate;
    this.createdDatetime = createdDatetime;
    this.createdBy = createdBy;
    this.updatedDatetime = updatedDatetime;
    this.updatedBy = updatedBy;
    this.createdById = createdById;
    this.updatedById = updatedById;
  }

  public toggleSelected() {
    this.selected = !this.selected;
  }
}



// WEBPACK FOOTER //
// ./src/models/patient-chart/patient-history/patient-history.ts